import {
  addDateFormatting,
  getCurrentLine,
  getCurrentLob,
  getStoreState,
  getUsersData,
  setStoreState,
  loadPolicyDetailDynamic,
  save,
} from '@cogitate/ui-multi-utils';
import {
  apolloKeys,
  cancellationKeys,
  dateKeys,
  flowKeys,
  notificationKeys,
  policySchemaKeys,
  reinstatementKeys,
  requestKeys,
  storeKeys,
} from 'ui/data/constants/keys';
import { faPen, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  dateFormatter,
  DDMSpecialClause,
  downloadForms,
  getAccountHubPremium,
  getCurrentUserRole,
  isDDMIntegrationActive,
  isRoleAgent,
  statusOptions,
} from 'ui/utilities/helper';
import {
  AccountHubNonPremiumPolicyStatus,
  AccountHubPolicyStatusMaster,
  PolicyStatusMaster,
  RenewalsPolicyStatusMaster,
  TransactionTypeMaster,
} from 'ui/data/constants/status';
import { StateMaster } from 'ui/data/constants/stateMaster';
import moment from 'moment';
import { commonKeys, payrollProtectionKeys, routeKeys } from 'ui/data/commercial/payrollprotection/constants/keys';
import NProgress from 'nprogress';
import { alertMsgs } from 'ui/data/constants/messages';
import { toast } from 'react-toastify';

export function convertAddress(addr) {
  return {
    ...addr,
    State: addr.State || addr.state || addr.AdministrationArea1 || '',
    Zip: addr.Zip || addr.Postalcode || addr.postalCode || '', // fallback to other possible keys
    Country: addr.Country || addr.country || addr.CountryCode || '', // fallback to other possible keys
    // ...other mappings as needed
  };
}

export const primaryLocationIndex = (policyData) =>
  policyData?.Risks?.PayrollProtectionUnit?.[0]?.PractitionerRiskAttributes?.PracticeLocationAddresses?.findIndex(
    (loc) => loc.IsPrimaryPracticeLocation === true
  );

export const getOfficeContacts = (policyData) => {
  const contacts = policyData?.Risks?.PayrollProtectionUnit?.[0]?.PractitionerRiskAttributes?.OfficeContacts || [];
  return contacts.map((contact) => ({
    ...contact,
    id: contact.id || Date.now() + Math.random(),
  }));
};

export const setOfficeContacts = (contacts, policyData) => {
  const updatedPolicyData = structuredClone(policyData);
  // if (
  //   updatedPolicyData?.Risks?.PayrollProtectionUnit?.[0]
  //     ?.PractitionerRiskAttributes?.PracticeLocationAddresses?.[
  //   primaryLocationIndex(policyData)
  //   ]
  // ) {
  // }
  updatedPolicyData.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.OfficeContacts = contacts;
  setStoreState(storeKeys.PolicyReducer, updatedPolicyData);
};

export const getAdditionalLocations = (policyData) => {
  return (
    policyData?.Risks?.PayrollProtectionUnit?.[0]?.PractitionerRiskAttributes?.PracticeLocationAddresses?.filter(
      (loc) => !loc.IsPrimaryPracticeLocation
    ) || []
  ).map((loc) => ({
    ...loc,
    id: loc.id || Date.now() + Math.random(),
  }));
};

// Helper to set all non-primary locations (preserving the primary)
export const setAdditionalLocations = (locations, policyData) => {
  const updatedPolicyData = structuredClone(policyData);
  const allLocations =
    updatedPolicyData?.Risks?.PayrollProtectionUnit?.[0]?.PractitionerRiskAttributes?.PracticeLocationAddresses || [];
  const primary = allLocations.find((loc) => loc.IsPrimaryPracticeLocation);
  updatedPolicyData.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.PracticeLocationAddresses = [
    ...(primary ? [primary] : []),
    ...locations,
  ];
  setStoreState(storeKeys.PolicyReducer, updatedPolicyData);

  // Force a re-render by updating the local state
  // setTimeout(() => {
  //   window.location.reload();
  // }, 100);
};

export const AddDetailTable = () => {
  return true;
};

const ColumnStyle = (cell, row, _rowIndex, _colIndex) => {
  return row?.Status === 'IsErrored' ? 'datatable-error' : 'success';
};

export const practitionerAdditionalContactsColumns = (state, setState, policyData) => {
  const PractitionerAdditionalContactsActions = (cell, row, rowIndex, _formatExtraData) => {
    return (
      <>
        <a
          className="display-inblock actionIcon me-1"
          data-bs-toggle="tooltip"
          title="Edit"
          onClick={() => {
            setState({
              editIndex: rowIndex,
              contactFormData: {
                ContactType: row.ContactType,
                ContactName: row.ContactName,
                ContactNumber: row.Communications?.[0]?.Value || '',
                ContactEmail: row.Communications?.[1]?.Value || '',
              },
            });
          }}
        >
          <FontAwesomeIcon icon={faPen} size="lg" />
        </a>
        <a
          className="display-inblock actionIcon me-1"
          data-bs-toggle="tooltip"
          title="Delete"
          onClick={() => {
            const { officeContacts } = state;
            const updatedContacts = officeContacts.filter((contact) => contact.id !== row.id);
            setState({
              officeContacts: updatedContacts,
              editIndex: null,
              contactFormData: {
                ContactType: '',
                ContactName: '',
                ContactNumber: '',
                ContactEmail: '',
              },
            });
            if (policyData) {
              policyData.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.OfficeContacts = updatedContacts;
              setOfficeContacts(updatedContacts, policyData);
            }
          }}
          onKeyPress={(_e) => {
            const { officeContacts, row } = state;
            const updatedContacts = officeContacts.filter((contact) => contact.id !== row.id);
            setState({
              officeContacts: updatedContacts,
              editIndex: null,
              contactFormData: {
                ContactType: '',
                ContactName: '',
                ContactNumber: '',
                ContactEmail: '',
              },
            });
            if (policyData) {
              policyData.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.OfficeContacts = updatedContacts;
              setOfficeContacts(updatedContacts, policyData);
            }
          }}
          tabIndex="0"
          role="button"
        >
          <FontAwesomeIcon icon={faTrashCan} size="lg" />
        </a>
      </>
    );
  };
  const columns = [
    {
      dataField: 'Number',
      text: 'No',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '10%' }),
    },
    {
      dataField: 'ContactType',
      text: 'CONTACT TYPE',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '20%' }),
    },
    {
      dataField: 'ContactName',
      text: 'CONTACT NAME',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '20%' }),
    },
    {
      dataField: 'Communications',
      text: 'CONTACT NUMBER',
      formatter: (cell, row) => row.Communications?.[0]?.Value || '',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '20%' }),
    },
    {
      dataField: 'Communications',
      text: 'CONTACT EMAIL ADDRESS',
      formatter: (cell, row) => row.Communications?.[1]?.Value || '',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '20%' }),
    },
    {
      dataField: 'Action',
      text: 'ACTIONs',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '10%' }),
      formatter: (cell, row, rowIndex, _formatExtraData) =>
        PractitionerAdditionalContactsActions(cell, row, rowIndex, _formatExtraData),
    },
  ];
  return columns;
};

export const practitionerAdditionalLocationsColumns = (state, setState, policyData) => {
  const PractitionerAdditionalLocationsActions = (cell, row, rowIndex, _formatExtraData) => {
    return (
      <>
        <a
          className="display-inblock actionIcon me-1"
          data-bs-toggle="tooltip"
          title="Edit"
          onClick={() => {
            setState({
              editLocationIndex: rowIndex,
              locationFormData: {
                Address: row,
                NickName: '',
                LocationNumber: 0,
                IsValid: false,
                IsPrimaryPracticeLocation: false,
                IsManual: row?.IsManual || false,
                StreetName: '',
                AddressLine1: row.AddressLine1 || '',
                AddressLine2: row.AddressLine1 || '',
                City: row.City || '',
                State: row.State || '',
                County: row.County || '',
                Zip: row.Postalcode || row.Zip || '',
                Country: row.Country || 'United States',
                CountyCode: '',
                CountryCode: '',
                PlaceId: row.PlaceId,
                Number: 0,
                Name: '',
                Long: row.Long,
                Lat: row.Lat,
                Description: '',
                AddressType: 'p',
                FormattedAddress: row.FormattedAddress,
                UnFormattedAddress: row.UnFormattedAddress,
                Status: '',
                AptSuite: '',
                PoBox: '',
                CityCode: '',
                Territory: '',
                TerritoryCode: '',
              },
            });
          }}
        >
          <FontAwesomeIcon icon={faPen} size="lg" />
        </a>
        <a
          className="display-inblock actionIcon me-1"
          data-bs-toggle="tooltip"
          title="Delete"
          onClick={() => {
            const currentLocations = getAdditionalLocations(policyData);
            const updatedLocations = currentLocations.filter((loc) => loc.id !== row.id);
            setState({
              additionalLocations: updatedLocations,
              editLocationIndex: null,
              locationFormData: {
                Address: {},
                NickName: '',
                LocationNumber: 0,
                IsValid: false,
                IsPrimaryPracticeLocation: false,
                IsManual: row.IsManual || false,
                StreetName: '',
                AddressLine1: row.AddressLine1 || '',
                AddressLine2: row.AddressLine1 || '',
                City: row.City || '',
                State: row.State || '',
                County: row.County || '',
                Zip: row.Postalcode || row.Zip || '',
                Country: row.Country || 'United States',
                CountyCode: '',
                CountryCode: '',
                PlaceId: row.PlaceId,
                Number: 0,
                Name: '',
                Long: row.Long,
                Lat: row.Lat,
                Description: '',
                AddressType: 'p',
                FormattedAddress: row.FormattedAddress,
                UnFormattedAddress: row.UnFormattedAddress,
                Status: '',
                AptSuite: '',
                PoBox: '',
                CityCode: '',
                Territory: '',
                TerritoryCode: '',
              },
            });
            if (policyData) {
              setAdditionalLocations(updatedLocations, policyData);
            }
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              const currentLocations = getAdditionalLocations(policyData);
              const updatedLocations = currentLocations.filter((loc) => loc.id !== row.id);
              setState({
                additionalLocations: updatedLocations,
                editLocationIndex: null,
                locationFormData: {
                  NickName: '',
                  LocationNumber: 0,
                  IsValid: false,
                  IsPrimaryPracticeLocation: false,
                  IsManual: row.IsManual || false,
                  StreetName: '',
                  AddressLine1: row.AddressLine1 || '',
                  AddressLine2: row.AddressLine1 || '',
                  City: row.City || '',
                  State: row.State || '',
                  County: row.County || '',
                  Zip: row.Postalcode || row.Zip || '',
                  Country: row.Country || 'United States',
                  CountyCode: '',
                  CountryCode: '',
                  PlaceId: row.PlaceId,
                  Number: 0,
                  Name: '',
                  Long: row.Long,
                  Lat: row.Lat,
                  Description: '',
                  AddressType: 'p',
                  FormattedAddress: row.FormattedAddress,
                  UnFormattedAddress: row.UnFormattedAddress,
                  Status: '',
                  AptSuite: '',
                  PoBox: '',
                  CityCode: '',
                  Territory: '',
                  TerritoryCode: '',
                },
              });
              if (policyData) {
                setAdditionalLocations(updatedLocations, policyData);
              }
            }
          }}
          tabIndex="0"
          role="button"
        >
          <FontAwesomeIcon icon={faTrashCan} size="lg" />
        </a>
      </>
    );
  };
  const columns = [
    {
      dataField: 'Number',
      text: 'No',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '5%' }),
    },
    {
      dataField: 'UnFormattedAddress',
      text: 'ADDRESS',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '35%' }),
      formatter: (cell) => {
        if (typeof cell === 'object') {
          return '';
        }
        return cell || '';
      },
    },
    {
      dataField: 'County',
      text: 'COUNTY',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '20%' }),
      formatter: (cell) => {
        if (typeof cell === 'object') {
          return '';
        }
        return cell || '';
      },
    },
    {
      dataField: 'Action',
      text: 'ACTIONs',
      sort: false,
      classes: ColumnStyle,
      headerStyle: () => ({ width: '10%' }),
      formatter: PractitionerAdditionalLocationsActions,
    },
  ];
  return columns;
};

// Minimal schemas for AddDetail forms
export const additionalContactSchema = () => [
  {
    key: 'ContactInfoCard',
    type: 'Card',
    title: '',
    className: ' clearfix',
    titleClassName: 'commonHead commonHeadPadding mt-2',
    childsClassName: 'boxWrapper px-3 ',
    controls: [
      {
        key: 'ContactType',
        label: 'Contact Type*',
        type: 'search-dropdown',
        needCapitalizeFirstChar: true,
        errorMessage: 'Please Enter First Name',
        labelClass: '',
        inputClass: 'col-md-2',
        positionClass: 'col-xxl-3 col-lg-4 col-md-6 mb-4',
        isColummnDisplay: false,
        props: {
          class: 'inputText',
          placeholder: 'Select',
          required: true,
        },
        options: [
          {
            key: 'OfficeManager',
            label: 'Office Manager',
            value: 'Office Manager',
          },
          {
            key: 'OtherOfficeStaff',
            label: 'Other Office Staff',
            value: 'Other Office Staff',
          },
        ],
        dataPath: 'ContactType',
      },
      {
        key: 'ContactName',
        label: 'Contact Name*',
        type: 'text',
        props: { class: 'inputText', placeholder: 'Enter', required: true },
        required: true,
        needCapitalizeFirstChar: true,
        errorMessage: 'Please Enter First Name',
        labelClass: '',
        inputClass: 'col-md-2',
        positionClass: 'col-xxl-3 col-lg-4 col-md-6 mb-4',
        isColummnDisplay: false,
        dataPath: 'ContactName',
      },
      {
        key: 'ContactNumber',
        label: 'Contact Number*',
        type: 'number2',
        props: {
          class: 'inputText',
          placeholder: 'Enter',
          maxlength: '10',
          required: false,
        },
        needCapitalizeFirstChar: true,
        errorMessage: 'Please Enter First Name',
        labelClass: '',
        inputClass: 'col-md-2',
        positionClass: 'col-xxl-3 col-lg-4 col-md-6 mb-4',
        isColummnDisplay: false,
        dataPath: 'ContactNumber',
      },
      {
        key: 'ContactEmail',
        label: 'Contact Email Address*',
        type: 'text',
        props: { class: 'inputText', placeholder: 'Enter', required: false },
        needCapitalizeFirstChar: true,
        errorMessage: 'Please Enter First Name',
        labelClass: '',
        inputClass: 'col-md-2',
        positionClass: 'col-xxl-3 col-lg-4 col-md-6 mb-4',
        isColummnDisplay: false,
        dataPath: 'ContactEmail',
      },
    ],
  },
];

export const additionalLocationSchema = () => [
  {
    key: 'LocationInfoCard',
    type: 'Card',
    title: '',
    className: ' clearfix',
    titleClassName: 'commonHead commonHeadPadding mt-2',
    childsClassName: 'boxWrapper px-3 ',
    controls: [
      {
        key: 'additional-locations',
        label: 'Address*',
        type: 'location',
        props: {
          required: true,
          class: 'col-md-10',
        },
        labelClass: 'inputLabel pt-2 mt-2',
        positionClass: 'col-md-9 mt-4',
        isColummnDisplay: false,
        dataPath: 'Address',
        conditionalDisplay: [
          {
            src: 'IsManual',
            exp: '!=',
            needRefComp: false,
            target: true,
            connector: '&&',
          },
        ],
      },
      {
        key: 'isManualAddress',
        type: 'switch',
        label: 'Add Manual Address',
        props: {
          class: 'inputText customCheckBox',
        },
        labelClass: 'd-flex align-items-center mx-2',
        inputClass: 'col-xxl-3 col-lg-4 col-md-6',
        positionClass: 'd-flex col-md-3 mt-4 pt-3',
        isColummnDisplay: false,
        dataPath: 'IsManual',
        options: [
          {
            value: 'true',
            label: 'Yes',
          },
        ],
        conditionalDisplay: [
          {
            src: 'IsManual',
            exp: '!=',
            needRefComp: false,
            target: true,
            connector: '&&',
          },
        ],
      },
      {
        key: 'isManualAddress1',
        type: 'switch',
        label: 'Add Manual Address',
        props: {
          class: 'inputText customCheckBox',
        },
        labelClass: 'd-flex align-items-center mx-2',
        inputClass: 'col-xxl-3 col-lg-4 col-md-6',
        positionClass: 'd-flex col-md-12 mt-4',
        isColummnDisplay: false,
        dataPath: 'IsManual',
        options: [
          {
            value: 'true',
            label: 'Yes',
          },
        ],
        conditionalDisplay: [
          {
            src: 'IsManual',
            exp: '==',
            needRefComp: false,
            target: true,
            connector: '&&',
          },
        ],
      },
      // {
      //   "key": "addressLine1",
      //   "label": "Street Address 1*",
      //   "props": {
      //     "required": true,
      //     "class": "inputText",
      //     "placeholder": "Street Address",
      //     "maxlength": "200",
      //     "disabled": true
      //   },
      //   "errorMessage": "Please enter Street Address",
      //   "inputClass": "flex-nowrap",
      //   "positionClass": "col-xxxl-3 col-xxl-4 col-lg-4 mt-4",
      //   "isColummnDisplay": false,
      //   "dataPath": "AddressLine1",
      //   "conditionalDisabled": [
      //     {
      //       "src": "IsManual",
      //       "exp": "==",
      //       "needRefComp": false,
      //       "target": false,
      //       "connector": "&&"
      //     }
      //   ]
      // },
      // {
      //   "key": "addressLine2",
      //   "label": "Street Address 2",
      //   "props": {
      //     "class": "inputText",
      //     "placeholder": "Street Address",
      //     "maxlength": "200",
      //     "disabled": true
      //   },
      //   "errorMessage": "Please enter Street Address",
      //   "inputClass": "flex-nowrap",
      //   "positionClass": "col-xxxl-3 col-xxl-4 col-lg-4 mt-4",
      //   "isColummnDisplay": false,
      //   "dataPath": "AddressLine2",
      //   "conditionalDisabled": [
      //     {
      //       "src": "IsManual",
      //       "exp": "==",
      //       "needRefComp": false,
      //       "target": false,
      //       "connector": "&&"
      //     }
      //   ]
      // },
      // {
      //   "key": "city",
      //   "label": "City*",
      //   "props": {
      //     "required": true,
      //     "class": "inputText",
      //     "placeholder": "City",
      //     "maxlength": "200",
      //     "disabled": true
      //   },
      //   "errorMessage": "Please enter City",
      //   "inputClass": "flex-nowrap",
      //   "positionClass": "col-xxxl-3 col-xxl-4 col-lg-4  mt-4",
      //   "isColummnDisplay": false,
      //   "dataPath": "City",
      //   "conditionalDisabled": [
      //     {
      //       "src": "IsManual",
      //       "exp": "==",
      //       "needRefComp": false,
      //       "target": false,
      //       "connector": "&&"
      //     }
      //   ]
      // },
      // {
      //   "key": "state",
      //   "label": "State*",
      //   "type": "search-dropdown",
      //   "props": {
      //     "required": true,
      //     "class": "inputText",
      //     "placeholder": "State",
      //     "maxlength": "2",
      //     "textCase": "uppercase",
      //     "disabled": true
      //   },
      //   "errorMessage": "Please enter State",
      //   "inputClass": "flex-nowrap",
      //   "positionClass": "col-xxxl-3 col-xxl-4 col-lg-4  mt-4",
      //   "isColummnDisplay": false,
      //   "dataPath": "State",
      //   "options": StateMaster,
      //   "conditionalDisabled": [
      //     {
      //       "src": "IsManual",
      //       "exp": "==",
      //       "needRefComp": false,
      //       "target": false,
      //       "connector": "&&"
      //     }
      //   ]
      // },
      // {
      //   "key": "zip",
      //   "label": "Zip*",
      //   "type": "number2",
      //   "props": {
      //     "required": true,
      //     "class": "inputText",
      //     "placeholder": "Zip",
      //     "maxlength": "6",
      //     "disabled": true
      //   },
      //   "errorMessage": "Please enter Zip",
      //   "inputClass": "flex-nowrap",
      //   "positionClass": "col-xxxl-3 col-xxl-4 col-lg-4 mt-4",
      //   "isColummnDisplay": false,
      //   "dataPath": "Zip",
      //   "conditionalDisabled": [
      //     {
      //       "src": "IsManual",
      //       "exp": "==",
      //       "needRefComp": false,
      //       "target": false,
      //       "connector": "&&"
      //     }
      //   ]
      // },
      // {
      //   "key": "country",
      //   "label": "Country*",
      //   // "type": "search-dropdown",
      //   "props": {
      //     "required": true,
      //     "class": "inputText",
      //     "placeholder": "Country",
      //     "disabled": true
      //   },
      //   "errorMessage": "Please enter Country",
      //   // "options": [
      //   //   {
      //   //     "key": "US",
      //   //     "label": "United States",
      //   //     "value": "United States"
      //   //   }
      //   // ],
      //   "inputClass": "flex-nowrap",
      //   "positionClass": "col-xxxl-3 col-xxl-4 col-lg-4 mt-4",
      //   "isColummnDisplay": false,
      //   "dataPath": "Country",
      //   "conditionalDisabled": [
      //     {
      //       "src": "IsManual",
      //       "exp": "==",
      //       "needRefComp": false,
      //       "target": false,
      //       "connector": "&&"
      //     }
      //   ]
      // }

      // {
      //   key: 'addressLine1',
      //   label: 'Street Address 1*',
      //   props: {
      //     required: true,
      //     class: 'inputText',
      //     placeholder: 'Street Address',
      //     maxlength: '200',
      //   },
      //   errorMessage: 'Please enter Street Address',
      //   inputClass: 'flex-nowrap',
      //   positionClass: 'col-xxxl-3 col-xxl-4 col-lg-4 mt-4',
      //   isColummnDisplay: false,
      //   dataPath: 'AddressLine1',
      //   conditionalDisplay: [
      //     {
      //       src: 'IsManual',
      //       exp: '==',
      //       needRefComp: false,
      //       target: true,
      //       connector: '&&',
      //     },
      //   ],
      // },
      // {
      //   key: 'addressLine2',
      //   label: 'Street Address 2',
      //   props: {
      //     class: 'inputText',
      //     placeholder: 'Street Address',
      //     maxlength: '200',
      //   },
      //   errorMessage: 'Please enter Street Address',
      //   inputClass: 'flex-nowrap',
      //   positionClass: 'col-xxxl-3 col-xxl-4 col-lg-4 mt-4',
      //   isColummnDisplay: false,
      //   dataPath: 'AddressLine2',
      //   conditionalDisplay: [
      //     {
      //       src: 'IsManual',
      //       exp: '==',
      //       needRefComp: false,
      //       target: true,
      //       connector: '&&',
      //     },
      //   ],
      // },
      // {
      //   key: 'city',
      //   label: 'City*',
      //   props: {
      //     required: true,
      //     class: 'inputText',
      //     placeholder: 'City',
      //     maxlength: '200',
      //   },
      //   errorMessage: 'Please enter City',
      //   inputClass: 'flex-nowrap',
      //   positionClass: 'col-xxxl-3 col-xxl-4 col-lg-4  mt-4',
      //   isColummnDisplay: false,
      //   dataPath: 'City',
      //   conditionalDisplay: [
      //     {
      //       src: 'IsManual',
      //       exp: '==',
      //       needRefComp: false,
      //       target: true,
      //       connector: '&&',
      //     },
      //   ],
      // },
      // {
      //   key: 'state',
      //   label: 'State*',
      //   type: 'textPA',
      //   props: {
      //     required: true,
      //     class: 'inputText',
      //     placeholder: 'State',
      //     maxlength: '2',
      //     textCase: 'uppercase',
      //   },
      //   errorMessage: 'Please enter State',
      //   inputClass: 'flex-nowrap',
      //   positionClass: 'col-xxxl-3 col-xxl-4 col-lg-4  mt-4',
      //   isColummnDisplay: false,
      //   dataPath: 'State',
      //   conditionalDisplay: [
      //     {
      //       src: 'IsManual',
      //       exp: '==',
      //       needRefComp: false,
      //       target: true,
      //       connector: '&&',
      //     },
      //   ],
      // },
      // {
      //   key: 'zip',
      //   label: 'Zip*',
      //   type: 'textAN',
      //   props: {
      //     required: true,
      //     class: 'inputText',
      //     placeholder: 'Zip',
      //     maxlength: '5',
      //   },
      //   errorMessage: 'Please enter Zip',
      //   inputClass: 'flex-nowrap',
      //   positionClass: 'col-xxxl-3 col-xxl-4 col-lg-4 mt-4',
      //   isColummnDisplay: false,
      //   dataPath: 'Zip',
      //   conditionalDisplay: [
      //     {
      //       src: 'IsManual',
      //       exp: '==',
      //       needRefComp: false,
      //       target: true,
      //       connector: '&&',
      //     },
      //   ],
      // },
      // {
      //   key: 'country',
      //   label: 'Country*',
      //   type: 'search-dropdown',
      //   props: {
      //     required: true,
      //     class: 'inputText',
      //     placeholder: 'Country',
      //   },
      //   errorMessage: 'Please enter Country',
      //   options: [
      //     { key: 'US', label: 'United States', value: 'United States' },
      //   ],
      //   inputClass: 'flex-nowrap',
      //   positionClass: 'col-xxxl-3 col-xxl-4 col-lg-4 mt-4',
      //   isColummnDisplay: false,
      //   dataPath: 'Country',
      //   conditionalDisplay: [
      //     {
      //       src: 'IsManual',
      //       exp: '==',
      //       needRefComp: false,
      //       target: true,
      //       connector: '&&',
      //     },
      //   ],
      // },

      // {
      //   key: 'county',
      //   label: 'County*',
      //   type: 'text',
      //   props: { class: 'inputText', placeholder: 'Enter County', required: true },
      //   required: true,
      //   labelClass: '',
      //   inputClass: 'col-md-2',
      //   positionClass: 'col-xxl-6 col-lg-6 col-md-6 mb-4',
      //   isColummnDisplay: false,
      //   dataPath: 'County',
      // },
    ],
  },
];

// Add this schema for policy details
export const policyDetailsSchema = [
  {
    key: 'policyDetailsCard',
    type: 'Card',
    title: '',
    className: '',
    titleClassName: 'commonHead pt-3 commonHeadPadding',
    childsClassName: 'boxWrapper px-3 commonShadow',
    controls: [
      {
        key: 'policyEffectiveDate',
        label: 'Desired coverage start date',
        type: 'date',
        props: {
          class: 'inputText',
          placeholder: 'MM/DD/YYYY',
          required: true,
        },
        labelClass: '',
        positionClass: 'col-md-3 mb-2 mt-3',
        isColummnDisplay: false,
        dataPath: 'Risks.PayrollProtectionUnit.0.PractitionerRiskAttributes.CoverageStartDate',
      },
      {
        key: 'policyExpirationDate',
        label: 'Desired coverage end date',
        type: 'date',
        props: {
          class: 'inputText',
          placeholder: 'MM/DD/YYYY',
          required: true,
          disabled: true,
        },
        labelClass: '',
        positionClass: 'col-md-3 mb-2 mt-3',
        isColummnDisplay: false,
        dataPath: 'Risks.PayrollProtectionUnit.0.PractitionerRiskAttributes.CoverageEndDate',
      },
    ],
  },
];

export const rowDataLocations = (policyData) => {
  return getAdditionalLocations(policyData).map((loc, idx) => ({
    ...loc,
    Number: idx + 1,
  }));
};

export const rowDataContacts = (policyData) => {
  return getOfficeContacts(policyData).map((contact, idx) => ({
    ...contact,
    Number: idx + 1,
  }));
};

export const initialFileChanges = (data) => {
  return data;
};

export const getAgentOptions = (value) => {
  const Masters = getStoreState(storeKeys.MasterReducer) || [];
  const option = Masters?.agents
    .filter((a) => a.Reference.includes(value))
    .map((a) => {
      return { key: a.Code, label: a.Name, value: a.Code };
    });
  return option;
};

const currencyFormatCoverage = (num, placeholder = 'Excluded') => {
  try {
    if (num === 'Excluded') {
      return placeholder;
    }
    if (typeof num === 'string' && num.length > 0) {
      num = num.replaceAll(',', '');
    }
    if (parseInt(num) === 0 || (num && !isNaN(num) && isFinite(num))) {
      num = num.toString();
      return (
        '$' +
        parseFloat(num)
          .toFixed(0)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      );
    } else {
      return '$0';
    }
  } catch (error) {
    throw Error();
  }
};

const getLimitAndPremium = (planName, policyData) => {
  const options = [];
  const premiumPlans = policyData.Risks.PayrollProtectionUnit[0].PremiumFactors.filter((factor) =>
    factor.Name.includes(planName)
  ).sort((a, b) => a.LimitAmount - b.LimitAmount);

  premiumPlans.forEach((plan) => {
    options.push({
      key: plan.Name.split('_')[1] || '',
      label: currencyFormatCoverage(plan.LimitAmount, '--'),
      value: plan.Name.split('_')[1],
    });
  });

  return options;
};

const setQuoteIndication = (flow, schema, dataModel, hasDDM) => {
  const clonedSchema = JSON.parse(JSON.stringify(schema));
  const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
  const fetchPermission = getStoreState(storeKeys.ApplicationReducer).DDM;
  const isAgent = loggedInUser.decodedJWT.role.toLowerCase() === 'agent';
  const isUnderWriter = loggedInUser.decodedJWT.role.toLowerCase() === 'underwriter';
  if (!hasDDM) {
    clonedSchema.forEach((s) => {
      s.controls = s.controls.filter((c) => {
        return c.key !== policySchemaKeys.UnderWriterDetails && c.key !== policySchemaKeys.LineOfBusiness;
      });
    });
  } else {
    if (!isUnderWriter && !fetchPermission?.UserDDMPermission) {
      clonedSchema.forEach((s) => {
        s.controls = s.controls.filter((c) => {
          return c.key !== policySchemaKeys.LineOfBusiness;
        });
      });
    }
  }

  return schema.map((s) => {
    s.controls = s.controls?.map((c) => {
      const agencyCode = dataModel?.Agency?.Code;

      switch (c.key) {
        case policySchemaKeys.AgencyDetails:
          if (!hasDDM) {
            c.type = 'search-dropdown';
            c.options = getUsersData('agencies', false);
          } else {
            if (isAgent) {
              c.props.disabled = true;
            } else {
              c.options = [{ key: '', label: 'Select...', value: '' }];
            }
          }
          break;

        case policySchemaKeys.AgentDetails:
          if (!hasDDM) {
            c.type = 'search-dropdown';
            if (agencyCode !== '') {
              c.options = getAgentOptions(agencyCode);
            }
          } else {
            if (isAgent) {
              c.props.disabled = true;
            } else {
              c.options = [{ key: '', label: 'Select...', value: '' }];
            }
          }
          break;

        case policySchemaKeys.UnderWriterDetails:
          if (isUnderWriter && hasDDM) {
            c.props.disabled = true;
          } else if (isAgent && hasDDM) {
            c.options = [{ key: '', label: 'Select...', value: '' }];
            c.props.disabled = false;
          }
          break;

        case payrollProtectionKeys.STATE:
        case payrollProtectionKeys.VERTERINARIAN_STATE: {
          c.options = StateMaster;
          break;
        }

        case payrollProtectionKeys.DATE_OF_BIRTH: {
          const d = moment().toDate();
          const minDOBFormat = addDateFormatting(dateKeys.Years, d, -100);
          const maxDOBFormat = addDateFormatting(dateKeys.Years, d, -18);

          c.props.minDate = moment(`${minDOBFormat}`);
          c.props.maxDate = moment(`${maxDOBFormat}`);
          break;
        }

        default:
          break;
      }
      return c;
    });
    return s;
  });
};

const setPolicyHolderInfo = (flow, schema, dataModel, hasDDM) => {
  const clonedSchema = JSON.parse(JSON.stringify(schema));
  const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
  const fetchPermission = getStoreState(storeKeys.ApplicationReducer).DDM;
  const isAgent = loggedInUser.decodedJWT.role.toLowerCase() === 'agent';
  const isUnderWriter = loggedInUser.decodedJWT.role.toLowerCase() === 'underwriter';
  if (!hasDDM) {
    clonedSchema.forEach((s) => {
      s.controls = s.controls.filter((c) => {
        return c.key !== policySchemaKeys.UnderWriterDetails && c.key !== policySchemaKeys.LineOfBusiness;
      });
    });
  } else {
    if (!isUnderWriter && !fetchPermission?.UserDDMPermission) {
      clonedSchema.forEach((s) => {
        s.controls = s.controls.filter((c) => {
          return c.key !== policySchemaKeys.LineOfBusiness;
        });
      });
    }
  }
  const Role = loggedInUser.decodedJWT.role;

  const isTransactionEnd = dataModel.Transaction.Type === TransactionTypeMaster.ENDORSEMENT;

  return schema.map((s) => {
    s.controls = s.controls?.map((c) => {
      const agencyCode = dataModel?.Agency?.Code;

      switch (c.key) {
        case policySchemaKeys.AgencyDetails:
          if (!hasDDM) {
            c.type = 'search-dropdown';
            c.options = getUsersData('agencies', false);
          } else {
            if (isAgent || isUnderWriter) {
              c.props.disabled = true;
            } else {
              c.options = [{ key: '', label: 'Select...', value: '' }];
            }
          }
          break;

        case policySchemaKeys.AgentDetails:
          if (!hasDDM) {
            c.type = 'search-dropdown';
            if (agencyCode !== '') {
              c.options = getAgentOptions(agencyCode);
            }
          } else {
            if (isAgent || isUnderWriter) {
              c.props.disabled = true;
            } else {
              c.options = [{ key: '', label: 'Select...', value: '' }];
            }
          }
          break;

        case policySchemaKeys.UnderWriterDetails:
          if (isUnderWriter && hasDDM) {
            c.props.disabled = true;
          } else if (isAgent && hasDDM) {
            c.options = [{ key: '', label: 'Select...', value: '' }];
            c.props.disabled = false;
          }
          break;

        case payrollProtectionKeys.PolicyEffectiveDate: {
          //Disable date for Endorsement flow
          if (isTransactionEnd) {
            c.props.disabled = true;
          } else {
            c.props.disabled = false;
          }

          //Role Wise min date
          let minDate = '';
          if (Role === 'Agent') {
            minDate = 0;
          } else if (Role === 'Underwriter') {
            minDate = -14;
          }

          const d = moment().toDate();
          const minEffectiveFormat = addDateFormatting(dateKeys.Days, d, minDate);
          const maxEffectiveFormat = addDateFormatting(dateKeys.Days, d, 60);
          const currentEffectiveDate = moment().format('YYYY-MM-DD');

          if (!isTransactionEnd) {
            const dataModelClone = structuredClone(dataModel);
            const maxExpirationDate = addDateFormatting(dateKeys.Days, d, 365);
            dataModelClone.EffectiveDate = currentEffectiveDate;
            dataModelClone.ExpirationDate = maxExpirationDate;
            setStoreState(storeKeys.PolicyReducer, dataModelClone);
            c.props.minDate = moment(`${minEffectiveFormat}`);
            c.props.maxDate = moment(`${maxEffectiveFormat}`);
          }
          break;
        }

        case payrollProtectionKeys.DATE_OF_BIRTH: {
          const d = moment().toDate();
          const maxDOBFormat = addDateFormatting(dateKeys.Years, d, -18);
          c.props.maxDate = moment(`${maxDOBFormat}`);
          break;
        }

        case payrollProtectionKeys.STATE:
        case payrollProtectionKeys.VERTERINARIAN_STATE: {
          c.options = StateMaster;
          break;
        }

        default:
          break;
      }
      return c;
    });
    return s;
  });
};

const setRiskQualifierInfo = (flow, schema, dataModel, hasDDM) => {
  return schema.map((s) => {
    s.controls = s.controls?.map((c) => {
      switch (c.key) {
        case payrollProtectionKeys.PayrollProtectionPlusLimit: {
          try {
            c.options = getLimitAndPremium('PPPremium_', dataModel);
          } catch {
            c.options = [];
          }
          break;
        }

        case payrollProtectionKeys.LeasedMedicalEquipmentLimit: {
          try {
            c.options = getLimitAndPremium('LeasedMedEquipPremium_', dataModel);
          } catch {
            c.options = [];
          }
          break;
        }

        case payrollProtectionKeys.MedicalPracticeLoanLimit: {
          try {
            const options = getLimitAndPremium('MedicalPracticeLoanPremium', dataModel, 'DisplayValue');
            c.options = options;
            c.props.value = options?.length > 0 ? options[0].value : '';
          } catch {
            c.options = [];
            c.props.value = '';
          }
          break;
        }

        case payrollProtectionKeys.PractitionerDateOfBirth: {
          const d = moment().toDate();
          const minDOBFormat = addDateFormatting(dateKeys.Years, d, -100);
          const maxDOBFormat = addDateFormatting(dateKeys.Years, d, -18);

          c.props.minDate = moment(`${minDOBFormat}`);
          c.props.maxDate = moment(`${maxDOBFormat}`);
          break;
        }

        default:
          break;
      }
      return c;
    });
    return s;
  });
};

export const AddDefaultValues = (url, schema, dataModel = {}, _role = 'UW', _extraparams = {}, hasDDM = false) => {
  // THIS IS DEFAULT FUNCTION FOR HOMEOWNER AND FLOOD AND GEN
  switch (url) {
    case routeKeys.QuoteIndication:
      schema = setQuoteIndication(flowKeys.Quote, schema, dataModel, hasDDM);
      break;
    case routeKeys.ApplicationPolicyHolder:
      schema = setPolicyHolderInfo(flowKeys.Application, schema, dataModel, hasDDM);
      break;
    case routeKeys.ApplicationRiskQualifiers:
      schema = setRiskQualifierInfo(flowKeys.Application, schema, dataModel, hasDDM);
      break;
  }

  return schema;
};

const defaultInputClause = {
  input: {
    clause: [{ src: '1', def: '1', exp: '=', operator: '' }],
    containerName: 'policy',
    LIMIT: 100,
    client: getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine?.client || process.env.NEXT_PUBLIC_CLIENT,
    line: getCurrentLine() || process.env.NEXT_PUBLIC_LINE,
    lob: getCurrentLob() || process.env.NEXT_PUBLIC_LINE_OF_BUSINESS,
  },
};

const dbKeys = {
  insuredname: 'c.InsuredAccount.DisplayName',
  typeOfInsured: 'c.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.PracticeType',
  npiNumber: 'c.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.NPINumber',
  vetId: 'c.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.VetID',
  fromdate: 'c.EffectiveDate',
  todate: 'c.EffectiveDate',
  propertyaddress: 'c.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.UnFormattedAddress',
  quoteNumber: 'c.QuoteNumber',
  policynumber: 'c.PolicyNumber',
  quoteVersion: 'c.QuoteVersion',
  agentName: 'c.Agent.Name',
  agencyName: 'c.Agency.Name',
  transactiondate: 'c.Transaction.Date',
  policystatus: 'c.PolicyStatus',
  underwriterid: 'c.UnderWriter.Name',
  state: 'c.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.State',
  agentid: 'c.Agent.Code',
  lob: 'c.Attributes.Lob',
  nonRenewal: 'c.NonRenewal',
};

export const replaceData = (initialData, isRenewal) => {
  return [
    {
      key: '"$STATUS_OPTIONS$"',
      value: statusOptions(isRenewal ? RenewalsPolicyStatusMaster : PolicyStatusMaster),
    },
    {
      key: '"$DATE$"',
      value: new Date(),
    },
    {
      key: '"$LOBS_OPTIONS$"',
      value: initialData?.Attributes?.LobsArr,
    },
    {
      key: '"$STATES_OPTIONS$"',
      value: initialData?.Attributes?.StatesArr,
    },
  ];
};

const getExpression = (key) => {
  if (key === 'fromdate') {
    return '>=';
  }
  if (key === 'todate') {
    return '<=';
  }
  if (
    [
      'policynumber',
      'quoteNumber',
      // "typeOfInsured",
      'npi_vetId',
      'state',
      'insuredname',
      // "fromdate",
      // "todate",
      'agentName',
      'agencyName',

      // 'agencyname',
      // 'agencyid',
      // 'agentid',
      // 'agentname',
      // 'underwriterid',
      // 'lob',
      // 'insuredname',
      // 'state',
      // 'policynumber',
      // 'quoteNumber',
    ].includes(key)
  ) {
    return 'LIKE';
  }
  return '=';
};

const buildClause = (key, value) => {
  const expression = getExpression(key);
  const clause = {
    src: dbKeys[key],
    def: `'${value}'`,
    exp: expression,
    operator: 'AND',
  };

  if (
    [
      'policynumber',
      'quoteNumber',
      // "typeOfInsured",
      'npi_vetId',
      'state',
      'insuredname',
      // "fromdate",
      // "todate",
      'agentName',
      'agencyName',

      // 'agencyname',
      // 'agencyid',
      // 'agentname',
      // 'agentid',
      // 'underwriterid',
      // 'lob',
      // 'insuredname',
      // 'state',
      // 'policynumber',
      // 'quoteNumber',
    ].includes(key)
  ) {
    clause.src = `UPPER(${dbKeys[key]})`;
    clause.def = `'%${value.toUpperCase()}%'`;
  }
  if ('npi_vetId' === key) {
    clause.src = `UPPER(${dbKeys['npiNumber']})`;
    clause.def = `'%${value.toUpperCase()}%' OR UPPER(${dbKeys['vetId']}) LIKE '%${value.toUpperCase()}%'`;
  }

  if ('nonRenewal' === key) {
    clause.src = dbKeys['nonRenewal'];
    clause.def = `${value}`;
    clause.exp = '=';
  }

  return clause;
};

const addInitialClauses = (input, isRenewal) => {
  const statusesToExclude = Object.values(RenewalsPolicyStatusMaster);

  if (isRenewal) {
    statusesToExclude.forEach((status) => {
      input.input.clause.push({
        src: 'c.PolicyStatus',
        def: `'${status}'`,
        exp: '=',
        operator: 'OR',
      });
    });
  } else {
    statusesToExclude.forEach((status) => {
      input.input.clause.push({
        src: 'c.PolicyStatus',
        def: `'${status}'`,
        exp: '!=',
        operator: 'AND',
      });
    });
  }

  input.input.clause.push({
    src: 'c.Attributes.Client',
    def: `'${process.env.NEXT_PUBLIC_CLIENT}'`,
    exp: '=',
    operator: 'AND',
  });

  input.input.clause.push({
    src: 'c.PolicyStatus',
    def: "'Voided'",
    exp: '!=',
    operator: 'AND',
  });

  input.input.clause.push({
    src: 'c.Attributes.Lob',
    def: `'${getCurrentLob()}'`, // Assuming getCurrentLob() returns the current lob
    exp: '=',
    operator: 'AND',
  });

  if (isDDMIntegrationActive()) {
    input = DDMSpecialClause(input);
  }

  return input;
};

export const getInputClause = (initialLoad, accounthubModel, isRenewal) => {
  const selectedBusinessLine = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  const { line, lob, client } = selectedBusinessLine ? selectedBusinessLine : {};
  defaultInputClause.input.client = client;
  defaultInputClause.input.line = line;
  defaultInputClause.input.lob = lob;

  let input = structuredClone(defaultInputClause);
  if (!initialLoad) {
    Object.keys(accounthubModel).forEach((key) => {
      if (accounthubModel[key] !== null && accounthubModel[key] !== undefined && accounthubModel[key] !== '') {
        input.input.clause.push(buildClause(key, accounthubModel[key]));
      }
    });
  }

  input = addInitialClauses(input, isRenewal);
  input.input.clause = input.input.clause.filter((clause) => clause.src !== undefined);
  return input;
};

export const processAccountHubData = (m, _IsRenew) => {
  const pga = m?.Risks?.PayrollProtectionUnit.find((f) => f.UnitNumber === '1')?.PracticeLocationAddresses;
  const dispAddress =
    pga?.UnFormattedAddress ||
    pga?.AddressLine1 +
      ', ' +
      pga?.AddressLine2 +
      ', ' +
      pga?.City +
      ', ' +
      pga?.State +
      ', ' +
      pga?.CountyCode +
      ', ' +
      pga?.Zip;

  const NPI_VetID =
    m.Risks?.PayrollProtectionUnit[0]?.PractitionerRiskAttributes?.PracticeType === 'Physician' ||
    m.Risks?.PayrollProtectionUnit[0]?.PractitionerRiskAttributes?.PracticeType === 'Dentist' ||
    m.Risks?.PayrollProtectionUnit[0]?.PractitionerRiskAttributes?.PracticeType === 'Chiropractor'
      ? m.Risks?.PayrollProtectionUnit[0]?.PractitionerRiskAttributes?.NPINumber
      : m.Risks?.PayrollProtectionUnit[0]?.PractitionerRiskAttributes?.VetID;

  const BusinessName = getBusinessName(m);

  return {
    id: m.id,
    InsuredName: BusinessName,
    TypeOfInsured: m.Risks?.PayrollProtectionUnit[0]?.PractitionerRiskAttributes?.PracticeType,
    NPI_VetID: NPI_VetID,
    EffectiveDate: m.EffectiveDate,
    Location: dispAddress,
    QuoteVersion: m.QuoteVersion !== null ? (m.QuoteVersion !== '' ? m.QuoteVersion : '') : '',
    Agent: m.Agent?.Name,
    Agency: m.Agency?.Name,
    TransactionDate: m.Transaction?.Date,
    Premium:
      m.TotalPremium?.AnnualPremiumWithFeesAndTaxes === 0 || AccountHubNonPremiumPolicyStatus.includes(m.PolicyStatus)
        ? '--'
        : getAccountHubPremium(m),
    Status: m.PolicyStatus,
    PolicyNumber: m.PolicyNumber !== '' ? m.PolicyNumber : m.QuoteNumber || '',
    QuoteNumber: m.QuoteNumber !== '' ? m.QuoteNumber : '',
    IsQuoteNumber: !m.PolicyNumber || m.PolicyNumber === '',
    // PolicyRemark: m.PolicyStatusRemark,
    // IsQuoteNumber: m.PolicyNumber.length <= 0,
    // AccountNumber: m.PolicyNumber,

    // BusinessName: m.InsuredAccount?.BusinessInfo?.BusinessName,
    // ExpirationDate: m.ExpirationDate,
    // ExpiringPolicyNumber: m.LinkedPolicyNumber,
    // ExpiringPremium: m.ExpiringPremium?.AnnualPremiumWithFeesAndTaxes,
    // RemainingDays: calculateDaysDifference(m?.EffectiveDate),
    // RenewalPolicyTerm: renewPolicyTerm(m),
    // IsRenew: IsRenew,
    // LastUpdatedDate:
    //   m.Audit?.LastUpdatedOn === null
    //     ? m.Audit?.CreatedOn
    //     : m.Audit?.LastUpdatedOn,

    // RenewalStatus: m.PolicyStatus,
    // Underwriter: m?.UnderWriter?.Name,
    // IsMaster: m.Attributes?.IsMasterPolicy,
    // ExternalRefrences: m.ExternalRefrences,
    // LOB: m.Attributes?.Lob,
    // RenewalPremium: m.TotalPremium?.AnnualPremiumWithFeesAndTaxes,
    // NonRenewal: m.NonRenewal,
    // NonRenewalReason: m.NonRenewalReason,
  };
};

export const getCoverageValue = (model, key, fieldKey = 'LimitAmount') => {
  return model?.Risks.PayrollProtectionUnit[0].Coverages.find((ele) => ele.Name === key)?.[fieldKey];
};

export const getPremiumValue = (model, key, fieldKey = 'Premium') => {
  return model?.Risks.PayrollProtectionUnit[0].PremiumFactors.find((ele) => ele.Name === key)?.[fieldKey];
};

export const commonkeyfetcher = async (_key) => {
  return commonKeys;
};

export const getPolicyRemark = (model) => {
  let remark = '';
  switch (model.PolicyStatus) {
    case AccountHubPolicyStatusMaster.SubmissionDeclined:
    case AccountHubPolicyStatusMaster.SubmissionDeclinedByUW:
    case AccountHubPolicyStatusMaster.ReferralAwaitingUWReview:
      remark = model.PolicyRemark;
      break;
    default:
      return '';
  }
  return {
    PolicyRemark: remark,
    Condition: remark.length > 0 ? true : false,
  };
};

export const fetchPolicyStatusHistory = (policy, _childPolicies) => {
  NProgress.start();
  const data = [];
  const LOB = policy.Attributes.Lob;

  policy.PolicyStatusHistory.map((item) => {
    data.push({
      LOB: LOB,
      status: item.NewStatus,
      creationDate: dateFormatter(item.ChangedDate),
      creationTime: item.ChangedDate.split('T').length > 1 ? moment(item.ChangedDate).format('h:mm:ss A') : '--',
      user: item?.ChangedBy,
      Remarks: item?.Remarks,
    });
  });

  NProgress.done();
  return data;
};

export const loadPolicyData = async (policy) => {
  try {
    const versionPolicy = getStoreState(storeKeys.VersionReducer);
    if (
      [
        PolicyStatusMaster.EndorsementInitiated,
        PolicyStatusMaster.EndorsementRequestAwaitingUWApproval,
        PolicyStatusMaster.EndorsementApprovedByUW,
        PolicyStatusMaster.EndorsementApprovedPendingPayment,
        PolicyStatusMaster.EndorsementDeclined,
      ].includes(policy.PolicyStatus) ||
      [
        PolicyStatusMaster.EndorsementInitiated,
        PolicyStatusMaster.EndorsementRequestAwaitingUWApproval,
        PolicyStatusMaster.EndorsementApprovedByUW,
        PolicyStatusMaster.EndorsementApprovedPendingPayment,
        PolicyStatusMaster.EndorsementDeclined,
      ].includes(versionPolicy?.PolicyStatus)
    ) {
      let resp = await loadPolicyDetailDynamic(policy.PolicyNumber, 'true', 'view', policy, 'versions');
      resp = JSON.parse(JSON.stringify(resp));
      setStoreState(storeKeys.PolicyReducer, resp[0]);
      return resp[0];
    }
  } catch (error) {
    console.error('❌ Error loading policy data:', error);
    throw error;
  }
};

export function isValidEmail(email) {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;
  return !emailRegex.test(email);
}

const initCheckoutErrorHandlerWrapper = (buttonKey) => (key, _, rootError) => {
  if (key === buttonKey) {
    if ((typeof rootError === 'object') & (rootError.name === 'AxiosError')) {
      toast.error(rootError.response?.data?.error || alertMsgs.Shared.SomethingWentWrong);
    } else {
      toast.error(alertMsgs.PaymentMsg.InvalidEmail);
    }
  }
};

export const customButtonConfigurations = (summary, setSummary, router) => {
  const minPolicyEffectiveDate = moment().format(dateKeys.DateFormatyyymmdd);
  const maxPolicyEffectiveDate = addDateFormatting(dateKeys.Days, moment().toDate(), 59);
  const versionPolicy = getStoreState(storeKeys.VersionReducer);
  let clonedSummary = JSON.parse(JSON.stringify(summary));
  const policy = Object.keys(versionPolicy).length > 0 ? versionPolicy : clonedSummary;

  // Only reset the date on forst time initiating the checkout process
  if (policy.PolicyStatus === PolicyStatusMaster.QuoteOffered) {
    const todayDate = moment().format(dateKeys.DateFormatyyymmdd);
    const oneYearFromToday = moment().add(12, 'months').format(dateKeys.DateFormatyyymmdd);

    const originalEffectiveDate = policy.EffectiveDate;
    if (!originalEffectiveDate || moment(originalEffectiveDate).isSameOrBefore(moment(), 'day')) {
      policy.EffectiveDate = todayDate;
      policy.ExpirationDate = oneYearFromToday;
    } else {
      policy.ExpirationDate = moment(originalEffectiveDate).add(12, 'months').format(dateKeys.DateFormatyyymmdd);
    }
  }

  const conditionalPolicy = Object.keys(versionPolicy).length > 0 ? versionPolicy : clonedSummary;
  const isEndorsementTransaction = conditionalPolicy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT;
  const isZeroDollarEndorsement = isEndorsementTransaction && conditionalPolicy.TotalPremium.EffectivePremium === 0;
  const isSlFilingFeeApplied =
    isEndorsementTransaction &&
    isZeroDollarEndorsement &&
    conditionalPolicy.PolicyRiskAttributes &&
    conditionalPolicy.PolicyRiskAttributes.WaiveFilingFee === false;
  const isEndorsementApprovedByUW = conditionalPolicy.PolicyStatus === PolicyStatusMaster.EndorsementApprovedByUW;

  const shouldForceCheckoutForZeroEndorsementWithFee = isSlFilingFeeApplied && isEndorsementApprovedByUW;

  const showProceedToCheckout =
    isEndorsementTransaction &&
    conditionalPolicy.TotalPremium.EffectivePremium <= 0 &&
    !shouldForceCheckoutForZeroEndorsementWithFee
      ? ''
      : 'ProceedToCheckout';

  const isStatusAgentSignaturePending = policy.PolicyStatus === PolicyStatusMaster.AgentSignaturePending;

  const isCoveragePlanSelected = policy.Risks.PayrollProtectionUnit[0]?.SelectedPlan_Payroll !== '';

  const data = [
    {
      key: showProceedToCheckout,
      props: {
        actionKey: showProceedToCheckout,
        buttonConfigKey: showProceedToCheckout,
        buttonLabel: 'Initiate Checkout Process',
        label: 'Initiate Checkout Process',
        header: 'Initiate Checkout Process',
        modalSize: 'md',
        submitLabel: 'Checkout',
        closeLabel: 'Cancel',
        schema: [
          {
            key: 'confirmationCard',
            type: 'text',
            title: '',
            className: 'clearfix',
            titleClassName: 'commonHead commonHeadPadding',
            childsClassName: 'mb-4',
            controls: [
              {
                key: 'policyEffectiveDate',
                label: 'Policy Effective Date',
                type: 'date2',
                props: {
                  required: true,
                  class: 'inputText',
                  dayPlaceholder: 'dd',
                  monthPlaceholder: 'mm',
                  yearPlaceholder: 'yyyy',
                  format: 'MM-dd-y',
                  disableClock: true,
                  clearIcon: false,
                  setDefaultDate: true,
                  setDefaultActiveDate: true,
                  minDate: minPolicyEffectiveDate,
                  maxDate: maxPolicyEffectiveDate,
                  disabled: versionPolicy.id ? true : false,
                },
                inputClass: 'd-flex flex-nowrap',
                labelClass: 'inputLabel',
                positionClass: 'col-md-6 align-self-start mt-4',
                isColummnDisplay: false,
                errorMessage: 'Please select valid date',
                dataPath: 'EffectiveDate',
              },
              {
                key: 'policyExpirationDate',
                label: 'Policy Expiration Date',
                type: 'date',
                props: {
                  class: 'inputText',
                  dayPlaceholder: 'dd',
                  monthPlaceholder: 'mm',
                  yearPlaceholder: 'yyyy',
                  format: 'MM-dd-y',
                  disableClock: true,
                  clearIcon: false,
                  disabled: true,
                },
                inputClass: 'd-flex flex-nowrap',
                labelClass: 'inputLabel',
                positionClass: 'col-md-6 align-self-start mt-4',
                isColummnDisplay: false,
                errorMessage: 'Please select valid date',
                dataPath: 'ExpirationDate',
              },
              {
                key: 'insuredEmailAddress',
                label: 'Insured Email Address*',
                type: 'email',
                props: {
                  required: true,
                  class: 'inputText',
                  placeholder: 'Enter Email ID',
                  maxLength: '200',
                  pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
                },
                labelClass: 'inputLabel ddlUnderwriterList',
                positionClass: 'col-xxxl-12 col-xxl-12 col-xl-12',
                isColummnDisplay: false,
                errorMessage: 'Please enter valid Email',
                dataPath: 'InsuredAccount.Communications.1.Value',
              },
            ],
          },
        ],
        initialFormModel: policy,
        validators: [
          {
            key: 'InsuredAccount.Communications[1].Value',
            validations: [
              {
                expression:
                  "$boolean($match(InsuredAccount.Communications[1].Value, /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/))",
                message: 'Please enter valid Email',
                priority: 1,
              },
            ],
          },
        ],
        preSuccess: async (actionKey, policy, formModel) => {
          if (actionKey === 'ProceedToCheckout') {
            const versionPolicy = getStoreState(storeKeys.VersionReducer);
            if (versionPolicy.id && versionPolicy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT) {
              policy = versionPolicy;
              policy.InsuredAccount.Communications.forEach((element) => {
                if (element.Type === 'Email') {
                  element.Value = formModel.InsuredAccount.Communications?.[1]?.Value;
                }
              });
              policy.NonFunctional.LastSubmittedPage = requestKeys.EndorsementCheckout;
            } else {
              policy = {
                ...policy,
                ...formModel,
                Attributes: { ...policy.Attributes, ...formModel.Attributes },
                Transaction: { ...policy.Transaction, ...formModel.Transaction },
                InsuredAccount: formModel.InsuredAccount
                  ? { ...policy.InsuredAccount, ...formModel.InsuredAccount }
                  : policy.InsuredAccount,
                NonFunctional: {
                  ...policy.NonFunctional,
                  ...formModel.NonFunctional,
                  LastSubmittedPage: requestKeys.ProceedToCheckout,
                },
              };
            }
          }
          return {
            policy: policy,
          };
        },
        postSuccess: async (actionKey, policy) => {
          if (actionKey === 'ProceedToCheckout') {
            const versionPolicy = getStoreState(storeKeys.VersionReducer);
            if (versionPolicy.id && versionPolicy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT) {
              setStoreState(storeKeys.VersionReducer, policy);
              toast.success(alertMsgs.Policy.ProceedToCheckout);
              setTimeout(() => {
                return router.push(routeKeys.DashboardAccountHub.toLowerCase());
              }, 100);
            } else {
              const updatedPolicy = {
                ...summary,
                ...policy,
                Attributes: { ...summary.Attributes, ...policy.Attributes },
                Transaction: { ...summary.Transaction, ...policy.Transaction },
                InsuredAccount: policy.InsuredAccount
                  ? { ...summary.InsuredAccount, ...policy.InsuredAccount }
                  : summary.InsuredAccount,
                Risks: policy?.Risks?.PayrollProtectionUnit?.length ? policy.Risks : summary.Risks,
                Underwriting: policy?.Underwriting
                  ? { ...summary.Underwriting, ...policy.Underwriting }
                  : summary.Underwriting,
                TotalPremium: policy?.TotalPremium
                  ? { ...summary.TotalPremium, ...policy.TotalPremium }
                  : summary.TotalPremium,
                NonFunctional: {
                  ...summary.NonFunctional,
                  ...policy.NonFunctional,
                },
              };
              setSummary(updatedPolicy);
              setStoreState(storeKeys.PolicyReducer, updatedPolicy);
              toast.success(alertMsgs.Policy.ProceedToCheckout);
            }
          }
          return {
            policy: policy,
          };
        },
        errorHandler: initCheckoutErrorHandlerWrapper('ProceedToCheckout'),
        onSchemaChange: (changedModel, key) => {
          if (key === 'policyEffectiveDate') {
            if (changedModel.EffectiveDate) {
              changedModel.ExpirationDate = moment(changedModel.EffectiveDate)
                .add(12, 'months')
                .format(dateKeys.DateFormatyyymmdd);
              changedModel.Transaction.EffectiveDate = changedModel.EffectiveDate;
            }
          }
          return changedModel;
        },
        onCloseModal: (key, changedModel) => {
          // if (key === 'ProceedToCheckout') {
          //   if (changedModel.EffectiveDate === todayDate) {
          //     changedModel.EffectiveDate = summary.EffectiveDate;
          //     changedModel.ExpirationDate = summary.ExpirationDate;
          //   }
          //   return changedModel;
          // }
          return null;
        },
      },
    },
    {
      key: 'ResendCheckoutEmail',
      props: {
        actionKey: 'ResendCheckoutEmail',
        buttonConfigKey: 'ResendCheckoutEmail',
        buttonLabel: `${isStatusAgentSignaturePending ? 'Resend Signature Link' : policy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT ? 'Resend Payment Link' : 'Resend Checkout Link'}`,
        label: `${isStatusAgentSignaturePending ? 'Resend Signature Link' : policy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT ? 'Resend Payment Link' : 'Resend Checkout Link'}`,
        header: `${isStatusAgentSignaturePending ? 'Resend Signature Link' : policy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT ? 'Resend Payment Link' : 'Resend Checkout Link'}`,
        modalSize: 'md',
        submitLabel: 'Resend',
        closeLabel: 'Cancel',
        schema: [
          {
            key: 'confirmationCard',
            type: 'text',
            title: '',
            className: 'clearfix',
            titleClassName: 'commonHead commonHeadPadding',
            childsClassName: 'mb-4',
            controls: [
              {
                key: 'policyEffectiveDate',
                label: 'Policy Effective Date',
                type: 'date',
                props: {
                  required: true,
                  disabled: true,
                  class: 'inputText',
                  dayPlaceholder: 'dd',
                  monthPlaceholder: 'mm',
                  yearPlaceholder: 'yyyy',
                  format: 'MM-dd-y',
                  disableClock: true,
                  clearIcon: false,
                  setDefaultDate: false,
                },
                inputClass: 'd-flex flex-nowrap',
                labelClass: 'inputLabel',
                positionClass: 'col-md-6 align-self-start mt-4',
                isColummnDisplay: false,
                errorMessage: 'Please select valid date',
                dataPath: 'EffectiveDate',
              },
              {
                key: 'policyExpirationDate',
                label: 'Policy Expiration Date',
                type: 'date',
                props: {
                  disabled: true,
                  class: 'inputText',
                  dayPlaceholder: 'dd',
                  monthPlaceholder: 'mm',
                  yearPlaceholder: 'yyyy',
                  format: 'MM-dd-y',
                  disableClock: true,
                  clearIcon: false,
                  disabled: true,
                },
                inputClass: 'd-flex flex-nowrap',
                labelClass: 'inputLabel',
                positionClass: 'col-md-6 align-self-start mt-4',
                isColummnDisplay: false,
                errorMessage: 'Please select valid date',
                dataPath: 'ExpirationDate',
              },
              {
                key: 'insuredEmailAddress',
                label: 'Insured Email Address*',
                type: 'email',
                props: {
                  required: true,
                  class: 'inputText',
                  placeholder: 'Enter Email ID',
                  maxLength: '200',
                  pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
                },
                labelClass: 'inputLabel ddlUnderwriterList',
                positionClass: 'col-xxxl-12 col-xxl-12 col-xl-12',
                isColummnDisplay: false,
                errorMessage: 'Please enter valid Email',
                conditionalDisplay: [
                  {
                    src: 'PolicyStatus',
                    exp: '!=',
                    isTargetValue: true,
                    target: PolicyStatusMaster.AgentSignaturePending,
                  },
                ],
                dataPath: 'InsuredAccount.Communications.1.Value',
              },
              {
                key: 'agentEmailAddress',
                label: 'Agent Email Address*',
                type: 'email',
                props: {
                  required: true,
                  class: 'inputText',
                  placeholder: 'Enter Email ID',
                  maxLength: '200',
                  pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
                  disabled: false,
                },
                labelClass: 'inputLabel ddlUnderwriterList',
                positionClass: 'col-xxxl-12 col-xxl-12 col-xl-12',
                isColummnDisplay: false,
                errorMessage: 'Please enter valid Email',
                conditionalDisplay: [
                  {
                    src: 'PolicyStatus',
                    exp: '==',
                    isTargetValue: true,
                    target: PolicyStatusMaster.AgentSignaturePending,
                  },
                ],
                dataPath: 'Agent.Communications.1.Value',
              },
            ],
          },
        ],
        initialFormModel: policy,
        validators: [
          {
            key: 'InsuredAccount.Communications[1].Value',
            validations: [
              {
                expression:
                  "$boolean($match(InsuredAccount.Communications[1].Value,/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z]{2,})+$/))",
                message: 'Please enter valid Email',
                priority: 1,
              },
            ],
          },
        ],
        preSuccess: async (actionKey, policy, formModel) => {
          if (actionKey === 'ResendCheckoutEmail') {
            if (isStatusAgentSignaturePending) {
              policy = formModel;
              policy.NonFunctional.LastSubmittedPage = requestKeys.ResendAgentSignatureEmail;
            } else {
              const versionPolicy = getStoreState(storeKeys.VersionReducer);
              if (versionPolicy?.Transaction?.Type === TransactionTypeMaster.ENDORSEMENT) {
                policy = versionPolicy;
                policy.InsuredAccount.Communications.forEach((element) => {
                  if (element.Type === 'Email') {
                    element.Value = formModel.InsuredAccount.Communications?.[1]?.Value;
                  }
                });
                policy.NonFunctional.LastSubmittedPage = requestKeys.ResendEndorsementCheckoutEmail;
              } else {
                policy = formModel;
                policy.NonFunctional.LastSubmittedPage = requestKeys.ResendCheckoutEmail;
              }
            }
          }
          return {
            policy: policy,
          };
        },
        postSuccess: async (actionKey, policy) => {
          if (actionKey === 'ResendCheckoutEmail') {
            // setSummary(policy);
            toast.success(
              isStatusAgentSignaturePending
                ? alertMsgs.Policy.ResendAgentSignatureEmail
                : alertMsgs.Policy.ResendCheckoutEmail
            );
            // router.push(routeKeys.DashboardAccountHub.toLocaleLowerCase());
          }
          return {
            policy: policy,
          };
        },
        errorHandler: initCheckoutErrorHandlerWrapper('ResendCheckoutEmail'),
        onSchemaChange: (changedModel, key) => {
          if (key === 'policyEffectiveDate') {
            changedModel.ExpirationDate = moment(changedModel.EffectiveDate).add(12, 'months').format('YYYY-MM-DD');
          }
          return changedModel;
        },
        onCloseModal: (key) => {
          if (key === 'ResendCheckoutEmail') {
            return summary;
          }
          return null;
        },
      },
    },
    {
      key: 'ReinstateRequested',
      props: {
        tableMode: true,
        actionKey: 'ReinstateRequested',
        buttonConfigKey: 'ReinstateRequested',
        buttonLabel: 'Request Reinstatement',
        label: 'Request Reinstatement',
        header: 'Request Reinstatement',
        modalSize: 'md',
        submitLabel: 'Submit',
        closeLabel: 'Cancel',
        schema: [
          {
            key: 'accountSummary',
            type: 'Card',
            title: '',
            className: 'clearfix',
            titleClassName: 'commonHead commonHeadPadding',
            childsClassName: '',
            controls: [
              {
                key: 'onRequestReinstatementFirstPara',
                label: '',
                type: 'label',
                value:
                  'Reinstatements are typically not approved for this product. It is recommended that you bind a new policy effective today.',
                props: {
                  disabled: 'true',
                  class: 'inputText',
                },
                labelClass: 'inputLabel',
                positionClass: 'col-xxxl-12 col-xxl-12 col-xl-12',
              },
              {
                key: 'onRequestReinstatementSecondPara',
                label: '',
                type: 'label',
                value: 'Are you sure you want to proceed with Reinstatement request?',
                props: {
                  disabled: 'true',
                  class: 'inputText',
                },
                labelClass: 'inputLabel',
                positionClass: 'col-xxxl-12 col-xxl-12 col-xl-12',
              },
            ],
          },
        ],
        initialFormModel: policy,
        preSuccess: async (actionKey, policy) => {
          if (actionKey === 'ReinstateRequested') {
            policy.NonFunctional.LastSubmittedPage = requestKeys.ReinstateRequested;
          }
          return {
            policy: policy,
          };
        },
        postSuccess: async (actionKey, policy) => {
          if (actionKey === 'ReinstateRequested') {
            policy.PolicyStatus = PolicyStatusMaster.PolicyCancelledReinstatementRequestPendingUWApproval;
            let resp = await save(
              policy,
              apolloKeys.UpdatePolicyStatus,
              commonKeys.EmptyString,
              commonKeys.EmptyString
            );
            setSummary(resp);
            toast.success(alertMsgs.Reinstatement.ReinstateRequested);
            router.push(routeKeys.DashboardAccountHub.toLocaleLowerCase());
          }
          return {
            policy: resp,
          };
        },
        errorHandler: () => {},
        onSchemaChange: (changedModel, key) => {
          return changedModel;
        },
        redirectOnClose: true,
        onRedirect: (type, { router, model }) => {
          if (type === 'close') {
            router.push(routeKeys.DashboardAccountHub.toLocaleLowerCase());
          }
        },
        onCloseModal: (key) => {
          // if (key === 'ReinstateRequested') {
          //   // router.push(routeKeys.DashboardAccountHub.toLocaleLowerCase());
          //   return summary;
          // }
          return null;
        },
      },
    },
    {
      key: 'DownloadQuoteProposal',
      props: {
        buttonConfigKey: 'DownloadQuoteProposal',
        buttonLabel: 'Download Quote Proposal',
        isRedirect: true,
        onClickCustomEvent: () => {
          const forms = {
            'Required Forms': [
              {
                formName: isCoveragePlanSelected ? 'Quote Proposal Letter' : 'Quote Indication Proposal Letter',
                IsMandatory: true,
              },
            ],
          };
          downloadForms(
            forms,
            policy,
            false,
            TransactionTypeMaster.QUOTE,
            isCoveragePlanSelected ? 'Quote Proposal' : 'Quote Indication Proposal'
          );
        },
      },
    },
  ];
  return data;
};

export const getBusinessName = (policy) => {
  const businessName = policy.InsuredAccount.BusinessInfo.BusinessName;
  const dbaName = policy.InsuredAccount.BusinessInfo.DBAName;
  return dbaName ? `${businessName} dba ${dbaName}` : businessName;
};

export const routerLanding = (router, route) => {
  router.push(route);
};

export const setDefaultValuesHandlerEndorsement = (schema, model) => {
  schema.forEach((s, index) => {
    s.controls.forEach((control) => {
      switch (control.key) {
        case 'endorsementEffectiveDate':
          control.type = 'date';
          if (getCurrentUserRole() === commonKeys.RoleAgent) {
            // Agent: when there is already one endorsement, can select only after last endorsement effective date till policy expiration (no backdating)
            const todaysDate = moment().toDate();
            const hasExistingEndorsement = model.Transaction?.Number >= 1;
            const lastEndorsementEffectiveDate = model.Transaction?.EffectiveDate
              ? moment(model.Transaction.EffectiveDate).toDate()
              : null;
            if (hasExistingEndorsement && lastEndorsementEffectiveDate) {
              control.props.minDate =
                lastEndorsementEffectiveDate > todaysDate ? lastEndorsementEffectiveDate : todaysDate;
            } else {
              control.props.minDate = todaysDate;
            }
            control.props.maxDate = model.ExpirationDate ? moment(model.ExpirationDate).toDate() : undefined;
          } else {
            control.props.minDate = model.Transaction.EffectiveDate;
          }
          break;
        default:
          break;
      }
    });
  });
  return schema;
};

export const setDefaultValuesHandlerCancellation = (schema, model) => {
  const lobSpecificData = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;

  const { line, lob, state, carrier, version } = lobSpecificData || {};

  const schemaState = getStoreState(storeKeys.SchemaReducer);

  const schemaFromBlob = schemaState[line]?.[lob]?.[state]?.[carrier]?.[version].policyservicing[1].Blob.UISchema;

  schema.forEach((s, index) => {
    s.controls.forEach((control) => {
      switch (control.key) {
        case 'cancellationtype':
          if (index === 1) {
            control.options = control.options.filter(
              (option) => !['shortratacancellation', 'flatcancellation'].includes(option.key)
            );
          }
          break;
        case 'businessname':
          if (index === 0) {
            control.label = getBusinessName(model);
          }
          break;
        case 'mailingaddress':
          if (index === 0) {
            control.value = 'Risk Address';
            control.label = model.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.UnFormattedAddress;
          }
          break;
        case 'policyeffectivedate':
          if (index === 0) {
            control.value = 'Policy Effective Date';
          }
          break;
        case 'policyenddate':
          if (index === 0) {
            control.value = 'Policy Expiration Date';
          }
          break;
        case 'reason':
          control.options = schemaFromBlob[1].controls.find((ctrl) => ctrl.key === 'reason').options;
          break;
        case 'requestedby':
          control.options = schemaFromBlob[1].controls.find((ctrl) => ctrl.key === 'requestedby').options;
          break;
        default:
          break;
      }

      if (index === 1) {
        s.controls = s.controls.filter(
          (c) =>
            ![
              cancellationKeys.schemaKeys.Cancellationmep,
              cancellationKeys.schemaKeys.PolicyFee,
              cancellationKeys.schemaKeys.InspectionFee,
            ].includes(c.key)
        );
      }
    });
  });
  return schema;
};

export const postCancelActions = async (key, model, router) => {
  let useDefaultFeature = true;
  switch (key) {
    case 'rateCancellation':
      // Save Billing Response to DB
      model = await save(model, apolloKeys.PutMutation, commonKeys.EmptyString, commonKeys.EmptyString);
      const buttonStatus = {
        cancellationcard: true,
      };
      const isUserAgent = getCurrentUserRole() === commonKeys.RoleAgent;
      const isFlatCancellation = model.Transaction.PremiumType === cancellationKeys.valueKeys.FlatCancellation;
      if (isUserAgent) {
        buttonStatus.hidePremium = true;
        if (!isFlatCancellation) {
          buttonStatus.showActionButton = true;
          buttonStatus.showApproveCancelationBtn = false;
          buttonStatus.showSubmitForApprovalBtn = true;
          buttonStatus.showRevertBtn = true;
        } else {
          buttonStatus.showActionButton = true;
          buttonStatus.showApproveCancelationBtn = true;
          buttonStatus.showSubmitForApprovalBtn = false;
          buttonStatus.showRevertBtn = true;
        }
      } else {
        buttonStatus.showActionButton = true;
        buttonStatus.showDownloadFormBtn = false;
        ((buttonStatus.showRevertBtn = true), (buttonStatus.showApproveCancelationBtn = true));
        buttonStatus.showSubmitForApprovalBtn = false;
      }
      return {
        useDefaultFeature: false,
        input: model,
        buttonStatus: buttonStatus,
      };
    case 'bindCancellation':
      // CALL Billings to SAVE CANCEL BALANCE
      model = await save(model, apolloKeys.DummyMutation, requestKeys.BillingCANCEL, commonKeys.EmptyString, -1);
      useDefaultFeature = false;
      model = await save(model, commonKeys.EmptyString, notificationKeys.CancellationApproved, commonKeys.EmptyString);
      toast.success(alertMsgs.Cancellation.PolicyCancelled);
      router.push(routeKeys.DashboardAccountHub.toLowerCase());
      return {
        useDefaultFeature: useDefaultFeature ?? true,
        input: model,
      };
    case 'submitForCancellationApproval':
      useDefaultFeature = false;
      // model = await save(
      //   model,
      //   commonKeys.EmptyString,
      //   notificationKeys.CancellationRequested,
      //   commonKeys.EmptyString
      // );
      router.push(routeKeys.DashboardAccountHub.toLowerCase());
      return {
        useDefaultFeature: useDefaultFeature ?? true,
        input: model,
      };
    case 'rejectTransaction':
      useDefaultFeature = false;
      // model = await save(
      //   model,
      //   commonKeys.EmptyString,
      //   notificationKeys.CancellationRejected,
      //   commonKeys.EmptyString
      // );
      router.push(routeKeys.DashboardAccountHub.toLowerCase());
      return {
        useDefaultFeature: useDefaultFeature ?? true,
        input: model,
      };
    default:
      return {
        useDefaultFeature: true,
        input: model,
        DocumentName: `${model.PolicyNumber}_CAN_${model.Transaction.Number}__CancellationDocument_${Date.now()}.pdf`,
        buttonStatus: {},
      };
  }
};

export const getCancellationButtonStatus = (model) => {
  const role = getCurrentUserRole();
  const { PolicyStatus, Transaction } = model;
  const { PremiumType } = Transaction || {};

  const baseConfig = {
    showActionButton: true,
    showCalculateBtn: false,
    cancellationcard: true,
  };

  const isReferralTriggered = model.Rules.Action === 'ReferToUW';

  if (role === commonKeys.RoleAgent && PolicyStatus === PolicyStatusMaster.CancellationInitiated) {
    return {
      ...baseConfig,
      showRevertBtn: true,
      hidePremium: true,
      ...(PremiumType === cancellationKeys.valueKeys.FlatCancellation || isReferralTriggered
        ? { showApproveCancelationBtn: true }
        : { showSubmitForApprovalBtn: true }),
    };
  }

  if (role === commonKeys.Underwriter) {
    if (PolicyStatus === PolicyStatusMaster.CancellationInitiated) {
      return {
        ...baseConfig,
        showApproveCancelationBtn: true,
        showDownloadFormBtn: false,
        showRevertBtn: true,
      };
    }

    if (PolicyStatus === PolicyStatusMaster.PolicyInForceCancellationRequestPendingApproval) {
      return {
        ...baseConfig,
        showApproveCancelationBtn: true,
        showDownloadFormBtn: false,
        showOnRejectBtn: true,
      };
    }
  }

  return;
};

export const setDefaultValuesHandlerReinstatement = (schema, model) => {
  const lobSpecificData = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;

  const { line, lob, state, carrier, version } = lobSpecificData || {};

  const schemaState = getStoreState(storeKeys.SchemaReducer);

  const schemaFromBlob = schemaState[line]?.[lob]?.[state]?.[carrier]?.[version].policyservicing[2].Blob.UISchema;

  schema.forEach((s, index) => {
    s.controls.forEach((control) => {
      switch (control.key) {
        case 'EffectiveDate':
          if (index === 1) {
            control.type = 'date';
            control.props.minDate = model.Transaction.EffectiveDate;
          }
          break;
        case 'businessname':
          if (index === 0) {
            control.label = getBusinessName(model);
          }
          break;
        case 'mailingaddress':
          if (index === 0) {
            control.value = 'Risk Address';
            control.label = model.Risks.PayrollProtectionUnit[0].PracticeLocationAddresses.UnFormattedAddress;
          }
          break;
        case 'policyeffectivedate':
          if (index === 0) {
            control.value = 'Policy Effective Date';
          }
          break;
        case 'policyenddate':
          if (index === 0) {
            control.value = 'Policy Expiration Date';
          }
          break;
        case 'reason':
          control.options = schemaFromBlob[1].controls.find((ctrl) => ctrl.key === 'reason').options;
          break;
        case 'requestedby':
          control.options = schemaFromBlob[1].controls.find((ctrl) => ctrl.key === 'requestedby').options;
          break;
        case 'reinstateterms':
          const isReasonOthers = model.Transaction.Reason == 'Other';
          if (isReasonOthers) {
            control.label = 'Reinstate Terms/Notes section*';
            control.props.required = true;
          } else {
            control.label = 'Reinstate Terms/Notes section';
            control.props.required = false;
          }
          break;
        default:
          break;
      }

      s.controls = s.controls.filter(
        (c) => ![reinstatementKeys.schemaKeys.PolicyFee, reinstatementKeys.schemaKeys.InspectionFee].includes(c.key)
      );
    });
  });
  return schema;
};

export const postReinstateActions = async (key, model, router) => {
  switch (key) {
    case 'rateReinstate':
      if (
        getCurrentUserRole() === commonKeys.Underwriter &&
        model.PolicyStatus === PolicyStatusMaster.ReInstatementInitiated
      ) {
        return {
          useDefaultFeature: false,
          input: model,
          buttonStatus: {
            showActionButton: true,
            showCalculateBtn: false,
            reinstatementcard: true,
            showApproveBtn: true,
            showDownloadFormBtn: false,
            showRevertBtn: true,
            showOnRejectBtn: false,
          },
        };
      } else if (
        getCurrentUserRole() === commonKeys.Underwriter &&
        model.PolicyStatus === PolicyStatusMaster.PolicyCancelledReinstatementRequestPendingUWApproval
      ) {
        return {
          useDefaultFeature: false,
          input: model,
          buttonStatus: {
            showActionButton: true,
            showCalculateBtn: false,
            reinstatementcard: true,
            showApproveBtn: true,
            showDownloadFormBtn: false,
            showRevertBtn: false,
            showOnRejectBtn: true,
          },
        };
      }
      break;
    case 'bindReinstate':
      // CALL Billings to SAVE REINSTATE BALANCE
      if (!(model.Transaction.Type === TransactionTypeMaster.ENDORSEMENT)) {
        model.PolicyStatus = PolicyStatusMaster.PolicyInForce;
        model.PolicyStatusRemarks = '';
        model = await save(model, apolloKeys.PutMutation, requestKeys.BillingREINSTATE, commonKeys.EmptyString);

        model = await save(
          model,
          commonKeys.EmptyString,
          notificationKeys.ReinstatementApproved,
          commonKeys.EmptyString
        );
      }
      toast.success(alertMsgs.Reinstatement.PolicyReinstated);
      router.push(routeKeys.DashboardAccountHub.toLowerCase());
      return {
        useDefaultFeature: false,
        input: model,
      };
    default:
      break;
  }
  return {
    useDefaultFeature: true,
    input: model,
    routePath: routeKeys.DashboardAccountHub.toLowerCase(),
  };
};

export const getReinstatementButtonStatus = (model) => {
  if (
    getCurrentUserRole() === commonKeys.Underwriter &&
    model.PolicyStatus === PolicyStatusMaster.ReInstatementInitiated
  ) {
    return {
      showActionButton: true,
      showCalculateBtn: false,
      reinstatementcard: true,
      showApproveBtn: true,
      showDownloadFormBtn: false,
      showRevertBtn: true,
      showOnRejectBtn: false,
    };
  } else if (
    getCurrentUserRole() === commonKeys.Underwriter &&
    model.PolicyStatus === PolicyStatusMaster.PolicyCancelledReinstatementRequestPendingUWApproval
  ) {
    return {
      showActionButton: true,
      showCalculateBtn: true,
      reinstatementcard: false,
      showApproveBtn: false,
      showDownloadFormBtn: false,
      showRevertBtn: false,
      showOnRejectBtn: false,
    };
  }
  return;
};

export const getCustomHeaders = (policy, transactionType, emailTitle) => {
  const loggedInUserDetails = getStoreState(storeKeys.LoggedInUserReducer)?.decodedJWT;
  const customHeaders = {
    'X-Cogitate-DMSPath': `'${policy.Attributes.Carrier}${policy.Attributes.Coverholder}/${policy.Attributes.Lob}/${policy.Attributes.State}/${policy.PolicyNumber}'`,
    'X-Cogitate-PolicyInfoId': `'${policy.PolicyNumber}'`,
    'X-Cogitate-PolicyNumber': `'${policy.PolicyNumber}'`,
    'X-Cogitate-CarrierCode': `'${policy.Attributes.Carrier}'`,
    'X-Cogitate-CoverholderCode': `'${policy.Attributes.Coverholder}'`,
    'X-Cogitate-Lob': `'${policy.Attributes.Lob}'`,
    'X-Cogitate-State': `'${policy.Attributes.State}'`,
    'X-Cogitate-TransactionCount': `'${policy.Transaction.Number}'`,
    'X-Cogitate-TransactionType': `'${transactionType}'`,
    'X-Cogitate-FolderName': `'Correspondence'`,
    'X-Cogitate-DocumentType':
      policy.Transaction.Number > 0 ? `'${emailTitle}_${policy.Transaction.Number}'` : `'${emailTitle}'`,
    'X-Cogitate-TransactionDate': `'${moment().toISOString()}'`,
    'X-Cogitate-UserName': `'${loggedInUserDetails?.FirstName} ${loggedInUserDetails?.LastName}'`,
    'X-Cogitate-FileName':
      policy.Transaction.Number > 0 ? `'${emailTitle}_${policy.Transaction.Number}'` : `'${emailTitle}'`,
    'X-Cogitate-ApplicationStatus': `'${policy.PolicyStatus}'`,
    'X-Cogitate-Tital': `'${emailTitle}'`,
  };

  return customHeaders;
};

const getLastEndorsementEffectiveDate = (policy, TransactionTypeMaster) => {
  const endorsementHistory = policy?.TransactionHistory?.filter(
    (history) => history?.Type === TransactionTypeMaster.ENDORSEMENT
  );

  if (!endorsementHistory || endorsementHistory.length === 0) return null;

  const maxEffectiveDate = endorsementHistory.reduce((maxDate, history) => {
    const currentDate = history?.EffectiveDate;
    return moment(currentDate).isAfter(maxDate) ? currentDate : maxDate;
  }, endorsementHistory[0].EffectiveDate);

  return moment(maxEffectiveDate).format('YYYY-MM-DD');
};

export const setDefaultValuesHandler = (schema, dataModel) => {
  schema = schema.map((s) => {
    s.controls = s.controls?.map((c) => {
      switch (c.key) {
        case policySchemaKeys.EndorsementEffectiveDate: {
          c.props.minDate =
            getLastEndorsementEffectiveDate(dataModel, TransactionTypeMaster) || dataModel.EffectiveDate;
          c.props.maxDate = dataModel.ExpirationDate;
          break;
        }
        default:
          break;
      }
      return c;
    });
    return s;
  });
  return schema;
};

export const getCustomStartEndorsementRedirection = (policyModel) => {
  const versionPolicy = getStoreState(storeKeys.VersionReducer) ?? policyModel;
  if (
    [PolicyStatusMaster.EndorsementRequestAwaitingUWApproval, PolicyStatusMaster.EndorsementApprovedByUW].includes(
      versionPolicy.PolicyStatus
    )
  ) {
    return routeKeys.EndorsementSummary;
  } else return routeKeys.PolicyHolderSubmit;
};

export const EndorsementSummaryActionButtons = (
  policy,
  role,
  PolicyStatusMaster,
  isBackdatedEndorsementAllowedForAgent
) => {
  const agentActionButtons = { showExitButton: true };
  const isPremiumIncreased = policy.TotalPremium.EffectivePremium > 0 ? true : false;
  const isAgent = role === 'Agent';
  if (isAgent) {
    const rulesActionAllowed = policy?.Rules?.Action === 'Allow';
    const selectedEffectiveDate = moment(policy.Transaction.EffectiveDate).format('YYYY-MM-DD');
    const currentDate = moment().format('YYYY-MM-DD');
    if (rulesActionAllowed && !isPremiumIncreased) {
      if (isBackdatedEndorsementAllowedForAgent || selectedEffectiveDate >= currentDate) {
        agentActionButtons.showApproveEndorsementButton = false;
        agentActionButtons.showCustomButton = true;
      } else {
        agentActionButtons.showApproveEndorsementButton = false;
        agentActionButtons.showSubmitForApprovalButton = false;
        agentActionButtons.showCustomButton = true;
      }
    } else if (!rulesActionAllowed && isAgent) {
      agentActionButtons.showApproveEndorsementButton = false;
      agentActionButtons.showCustomButton = true;
    } else if (isPremiumIncreased && policy.PolicyStatus === PolicyStatusMaster.EndorsementInitiated) {
      agentActionButtons.showApproveEndorsementButton = false;
      agentActionButtons.showCustomButton = true;
    }
  }

  const waiveFilingFee = policy.PolicyRiskAttributes?.WaiveFilingFee;
  const isZeroDollarEndorsementWithSlFee =
    policy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT &&
    policy.TotalPremium.EffectivePremium === 0 &&
    waiveFilingFee === false;

  if (
    isAgent &&
    policy.PolicyStatus === PolicyStatusMaster.EndorsementApprovedByUW &&
    isZeroDollarEndorsementWithSlFee
  ) {
    agentActionButtons.showCustomButton = false;
    agentActionButtons.showApproveEndorsementButton = false;
    agentActionButtons.showSubmitForApprovalButton = false;
  }

  const userRoles = {
    Agent: [
      {
        policyStatus: PolicyStatusMaster.EndorsementInitiated,
        actionButtons: agentActionButtons,
      },
      {
        policyStatus: PolicyStatusMaster.EndorsementApprovedByUW,
        actionButtons: agentActionButtons,
      },
    ],
    Underwriter: [
      {
        policyStatus: PolicyStatusMaster.EndorsementInitiated,
        actionButtons: {
          showExitButton: true,
          showRejectButton: false,
          showOnHoldButton: false,
          showReviewFormsButton: false,
          showApproveEndorsementButton: false,
          showCustomButton: true,
        },
      },
      {
        policyStatus: PolicyStatusMaster.EndorsementRequestAwaitingUWApproval,
        actionButtons: {
          showExitButton: true,
          showRejectButton: true,
          showOnHoldButton: false,
          showReviewFormsButton: false,
          showApproveEndorsementButton: false,
          showCustomButton: true,
        },
      },
      {
        policyStatus: PolicyStatusMaster.EndorsementApprovedByUW,
        actionButtons: {
          showExitButton: true,
          showRejectButton: false,
          showOnHoldButton: false,
          showReviewFormsButton: false,
          showApproveEndorsementButton: false,
        },
      },
    ],
  };

  const roleConfig = userRoles[role]?.find((val) => val.policyStatus === policy.PolicyStatus);
  return roleConfig ? roleConfig.actionButtons : {};
};

export const customOnEndorsementSubmit = async (policy, router) => {
  try {
    NProgress.start();
    const LoggedInUserReducer = getStoreState(storeKeys.LoggedInUserReducer);
    const isPremiumIncreased = policy.TotalPremium.EffectivePremium > 0 ? true : false;
    const isZeroDollarEndorsement = policy.TotalPremium.EffectivePremium === 0;

    let dataObject = {};
    if (isRoleAgent(LoggedInUserReducer)) {
      const isEndorsementInitiated = policy.PolicyStatus === PolicyStatusMaster.EndorsementInitiated;

      if (
        policy?.Rules?.Action !== 'Allow' ||
        (isPremiumIncreased && isEndorsementInitiated) ||
        (isZeroDollarEndorsement && isEndorsementInitiated)
      ) {
        dataObject.route = routeKeys.OnSubmitToUwEnd;
        dataObject.alertMsgs = alertMsgs.Endorsement.EndorsementSubmitted;
      } else {
        dataObject.route = routeKeys.IssueEndorsement;
        dataObject.alertMsgs = alertMsgs.Endorsement.EndorsementBound;
      }
    } else {
      dataObject.route = routeKeys.EndorsementApproved;
      dataObject.alertMsgs = alertMsgs.Endorsement.EndorsementApproved;
    }

    const resp = await save(policy, commonKeys.EmptyString, dataObject.route, commonKeys.EmptyString);

    if (resp) {
      setStoreState(storeKeys.VersionReducer, resp);
      dataObject.alertMsgs && toast.success(dataObject.alertMsgs);
      router.push(routeKeys.DashboardAccountHub.toLocaleLowerCase());
    }

    NProgress.done();
  } catch (error) {
    NProgress.done();
  }
};

const singleAddititionalPractitioner = {
  Status: 'Active',
  FirstName: '',
  MiddleName: '',
  LastName: '',
  Suffix: '',
  DateOfBirth: '1950-01-01',
  Age: '',
  Smoker: '',
};
export const buildCoveredPractitionerElement = (model) => {
  const singleObject = JSON.parse(JSON.stringify(singleAddititionalPractitioner));
  const coveredPractitionersCount = model.Attributes.NoOfAdditionalPractitioners;
  if (Number(coveredPractitionersCount) === 0) {
    model.Attributes.PercentageOfRevenue = '';
  }
  let currentAdditionalPractitioners = model.Risks.PayrollProtectionUnit[0].AdditionalPractitioners;
  let additionalPractitionersCount = currentAdditionalPractitioners?.length;

  if (coveredPractitionersCount > additionalPractitionersCount) {
    for (var i = 1; i < coveredPractitionersCount - additionalPractitionersCount + 1; i++) {
      currentAdditionalPractitioners.push({
        ...singleObject,
        UnitId: crypto.randomUUID(),
        UnitNumber: additionalPractitionersCount + i,
      });
    }
  } else if (coveredPractitionersCount < currentAdditionalPractitioners?.length) {
    for (var i = 0; i < additionalPractitionersCount - coveredPractitionersCount; i++) {
      currentAdditionalPractitioners.pop();
    }
  } else if (coveredPractitionersCount == additionalPractitionersCount) {
    //Do nothing
  } else {
    currentAdditionalPractitioners = [];
  }
  return model;
};

export const buttonTextConfig = (policy) => {
  const isPremiumIncreased = policy.TotalPremium.EffectivePremium > 0 ? true : false;
  const LoggedInUserReducer = getStoreState(storeKeys.LoggedInUserReducer);
  const isZeroDollarEndorsement = policy.TotalPremium.EffectivePremium === 0;
  const waiveFilingFee = policy.PolicyRiskAttributes?.WaiveFilingFee;
  const isZeroDollarEndorsementWithSlFee =
    policy.Transaction.Type === TransactionTypeMaster.ENDORSEMENT &&
    isZeroDollarEndorsement &&
    waiveFilingFee === false;
  const isEndorsementApprovedByUW = policy.PolicyStatus === PolicyStatusMaster.EndorsementApprovedByUW;

  let customBtnText = '';

  if (isRoleAgent(LoggedInUserReducer)) {
    if (
      policy?.Rules?.Action !== 'Allow' ||
      (isPremiumIncreased && policy.PolicyStatus === PolicyStatusMaster.EndorsementInitiated) ||
      (isZeroDollarEndorsement && policy.PolicyStatus === PolicyStatusMaster.EndorsementInitiated)
    ) {
      customBtnText = 'Submit To UW';
    } else if (!isPremiumIncreased && !(isZeroDollarEndorsementWithSlFee && isEndorsementApprovedByUW)) {
      customBtnText = 'Issue Endorsement';
    }
  } else {
    if (
      [PolicyStatusMaster.EndorsementRequestAwaitingUWApproval, PolicyStatusMaster.EndorsementInitiated].includes(
        policy.PolicyStatus
      )
    ) {
      customBtnText = 'Approve Endorsement';
    }
  }

  return { CustomBtnText: customBtnText, RejectBtnText: 'Decline Endorsement' };
};
